import fp from 'lodash/fp'
import { createAction } from 'redux-actions'
import uuid from 'uuid'

export const types = {
  ADD: 'matches/shots/ADD',
  REMOVE: 'matches/shots/REMOVE',
  CLEAR: 'matches/shots/CLEAR'
}

export const actions = {
  add: createAction(types.ADD),
  remove: createAction(types.REMOVE),
  clear: createAction(types.CLEAR)
}

export const selectors = {
  getShots: s => s.items
}

export const initialState = {
  // {
  //   "01876b96-d0f8-436b-a851-31ffc87f29f5": {
  //     position: { longitude: 10, latitude: 56 },
  //     createdAt: 14251241231,
  //     deletedAt: null
  //   }
  // }
  items: {}
}

const invalidRemove = fp.flow(fp.get('shotId'), fp.isNil)

export default function reducer (state = initialState, { payload, type } = {}) {
  switch (type) {
    case types.ADD:
      return fp.set(`items.${uuid.v4()}`, { createdAt: Date.now() }, state)
    case types.REMOVE:
      if (invalidRemove(payload)) {
        console.error('Invalid payload in \'shots/REMOVE\'')
      }
      return fp.update(`items.${payload.shotId}.deletedAt`, Date.now(), state)

    case types.CLEAR:
      return initialState

    default:
      return state
  }
}
